var _defs, _rect, _rect2, _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #afbdc7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #d6dee2;\n      }\n\n      .cls-4 {\n        fill: #1e96ff;\n      }\n\n      .cls-5 {\n        fill: #0078e1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 10.73,
    width: 2.12,
    height: 2.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0,
    y: 9.62,
    width: 17.88,
    height: 2.23,
    rx: 1.11,
    ry: 1.11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.88,0H3.12c-.55,0-1,.45-1,1v10.84h15.76v-7.84l-2.66-1.35-1.34-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.88,3c0,.55.45,1,1,1h3L13.88,0v3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 6.67,
    width: 9.6,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 8.84,
    width: 9.6,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.2,
    y: 4.51,
    width: 4.8,
    height: 0.72,
    rx: 0.36,
    ry: 0.36
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,11.84h18.99c.55,0,1.01.45,1.01,1.01v6.15c0,.55-.45,1.01-1.01,1.01H1.01C.45,20,0,19.55,0,18.99v-7.15H0Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.42,17.04c0,.85-.67,1.34-1.96,1.34h-2.54v-4.9h2.4c1.23,0,1.86.51,1.86,1.27,0,.49-.25.87-.65,1.08.55.18.9.6.9,1.21ZM5.05,14.33v1.16h1.13c.55,0,.85-.2.85-.58s-.3-.57-.85-.57h-1.13ZM7.28,16.92c0-.41-.31-.61-.9-.61h-1.32v1.21h1.32c.59,0,.9-.18.9-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.28,13.47h1.13v4.9h-1.13v-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.07,13.47v4.9h-.93l-2.44-2.98v2.98h-1.12v-4.9h.94l2.44,2.98v-2.98h1.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.2285ccb3ffc124f20b30b71cf56536f7.svg";
export { ForwardRef as ReactComponent };